import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edd60d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "QuotationOfWantToBuy" }
const _hoisted_2 = { class: "user" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "tags" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "priceWapper" }
const _hoisted_12 = { class: "price" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "他的报价:", -1))
const _hoisted_14 = { class: "number" }
const _hoisted_15 = { class: "address" }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = { class: "right" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("电话联系")
const _hoisted_19 = { class: "desc" }
const _hoisted_20 = { class: "descContent" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = { class: "images" }
const _hoisted_23 = { class: "imgWarpper" }
const _hoisted_24 = {
  key: 0,
  class: "actions"
}
const _hoisted_25 = { class: "tips" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "btns" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("采纳该报价")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_30 = { class: "telNum" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "videoWarpper" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanEmpty = _resolveComponent("VanEmpty")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.list.length)
      ? (_openBlock(), _createBlock(_component_VanList, {
          key: 0,
          class: "list",
          loading: $setup.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
          onLoad: $setup.getList,
          finished: $setup.finished,
          "immediate-check": false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["listItem", $setup.stateClass(item)])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_VanImage, {
                    size: "large",
                    src: item.avatarUrl,
                    round: "",
                    width: "48",
                    height: "48"
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.nickName), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString($setup.moment(item.createTime).fromNow()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode($setup["VipTag"], {
                        type: item.vipRank,
                        year: item.year
                      }, null, 8, ["type", "year"]),
                      _withDirectives(_createVNode(_component_VanTag, {
                        size: "small",
                        plain: "",
                        color: "#079BFD"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, item.hasIdCard]
                      ]),
                      _withDirectives(_createVNode(_component_VanTag, {
                        size: "small",
                        plain: "",
                        color: "#6775D2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, item.hasBusinessLicense]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.price) + "/株", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, "发货地区: " + _toDisplayString(item.address), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_VanButton, {
                        round: "",
                        block: "",
                        type: "danger",
                        size: "small",
                        onClick: ($event: any) => ($setup.getTel(item.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.profile), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.photos, (image, idx) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_VanImage, {
                          size: "large",
                          src: image,
                          width: "72",
                          height: "72",
                          radius: "8",
                          onClick: ($event: any) => ($setup.showImage(item,idx))
                        }, null, 8, ["src", "onClick"]),
                        (item.video.length && idx === 0)
                          ? (_openBlock(), _createBlock(_component_VanIcon, {
                              key: 0,
                              class: "play",
                              name: "play-circle-o",
                              size: "40",
                              color: "#FFF",
                              onClick: ($event: any) => ($setup.playVideo(item.video[0]))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ])
                ]),
                (!item.isAccept)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        (!item.hasOwnProperty("isAccept"))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "是否采纳该报价?"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_VanButton, {
                          size: "small",
                          onClick: _withModifiers(($event: any) => ($setup.refuse(item.id)), ["stop"]),
                          disabled: item.hasOwnProperty("isAccept") && !item.isAccept
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.hasOwnProperty("isAccept")?'已忽略':'忽略'), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"]),
                        (!item.hasOwnProperty("isAccept"))
                          ? (_openBlock(), _createBlock(_component_VanButton, {
                              key: 0,
                              size: "small",
                              onClick: _withModifiers(($event: any) => ($setup.adopt(item.id,idx)), ["stop"])
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 256))
          ]),
          _: 1
        }, 8, ["loading", "finished"]))
      : (_openBlock(), _createBlock(_component_VanEmpty, {
          key: 1,
          description: "暂无没有报价"
        })),
    _createVNode($setup["RestrictDialog"], {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "supply"
    }, null, 8, ["modelValue", "code"]),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_31)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      class: "adoptDialog",
      show: $setup.isShowVideo,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.isShowVideo) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isShowVideo = false)),
            style: {"z-index":"99999999999"}
          }, [
            _createVNode(_component_VanButton, {
              size: "mini",
              color: "#FFCC32"
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_VideoPlayer, {
            class: "video",
            src: $setup.videoUrl,
            autoplay: "",
            loop: "",
            language: "zh",
            controls: ""
          }, {
            default: _withCtx(({ player, state }) => []),
            _: 1
          }, 8, ["src"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}